import React, { useCallback } from 'react'
import { Accept, DropzoneOptions, FileRejection, useDropzone } from 'react-dropzone'
import block from 'bem-cn'

import { dragDropDefaultProps } from './DragDropZone.utils'

import './DragDropZone.scss'

interface IDragDropZoneProps extends DropzoneOptions {
  maxFiles?: number
  accept?: Accept
  maxSize?: number
  onChange: (acceptedFile: File[]) => void
  name: string
  callbackForLargeFile?: () => void
  callbackForInvalidFile?: () => void
}

const b = block('drop-zone')

export const DragDropZone: React.FC<IDragDropZoneProps> = ({
  children,
  onChange,
  name,
  callbackForLargeFile,
  callbackForInvalidFile,
  ...props
}) => {
  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      onChange(acceptedFiles)

      fileRejections.forEach(file => {
        file.errors.forEach(err => {
          if (err.code === 'file-too-large') {
            callbackForLargeFile?.()
          }

          if (err.code === 'file-invalid-type') {
            callbackForInvalidFile?.()
          }
        })
      })
    },
    [onChange, callbackForLargeFile, callbackForInvalidFile],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    ...dragDropDefaultProps,
    ...props,
  })

  return (
    <div className={b({ active: isDragActive })} {...getRootProps()}>
      <input name={name} {...getInputProps()} />
      {children}
    </div>
  )
}
